module.exports = __webpack_public_path__ + "img/icon_04.1d577540.png";